module.exports = __webpack_public_path__ + "img/安卓1.f7257a58.png";